// this code for create bulk order request from agent dash board button : bulk order
// export default AgentBulkOrderRequest;
import { useNavigate } from "react-router-dom";
import {
  getDoc,
  doc,
  collection,
  setDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore"; // Adjust path as needed
import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../../firebase";

const AgentBulkOrderRequest = () => {
  const [agentData, setAgentData] = useState(null);
  const [pricePerCard, setPricePerCard] = useState(null);
  const [bulkOrderInputs, setBulkOrderInputs] = useState([
    { rationCardNumber: "", name: "" },
  ]);
  const [activeTab, setActiveTab] = useState("credits");
  const navigate = useNavigate();

  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, async (user) => {
  //     if (user) {
  //       try {
  //         const userRef = doc(db, "users", user.uid);
  //         const userSnap = await getDoc(userRef);
  //         if (userSnap.exists()) {
  //           const userData = { ...userSnap.data(), id: userSnap.id };
  //           setAgentData(userData);
  //         }

  //         // ✅ Fetch price directly from priceConfigure
  //         const priceRef = doc(db, "admin", "priceconfigure");
  //         const priceSnap = await getDoc(priceRef);
  //         if (priceSnap.exists()) {
  //           const priceData = priceSnap.data();
  //           console.log("Fetched price data:", priceData);
  //           const bulkPrice = priceData?.bulkOrder;
  //           if (bulkPrice) {
  //             setPricePerCard(bulkPrice);
  //           } else {
  //             console.warn("bulkOrder price not found in priceConfigure");
  //           }
  //         } else {
  //           console.warn("priceConfigure document does not exist");
  //         }
  //       } catch (error) {
  //         console.error("Error fetching user or price data:", error);
  //       }
  //     } else {
  //       navigate("/login");
  //     }
  //   });

  //   return () => unsubscribe();
  // }, [navigate]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login");
        return;
      }

      try {
        // Fetch agent data
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (!userSnap.exists()) {
          console.warn("User document not found");
          return;
        }
        const userData = { ...userSnap.data(), id: userSnap.id };
        setAgentData(userData);

        // Fetch price per card
        const priceRef = doc(db, "admin", "priceconfigure");
        const priceSnap = await getDoc(priceRef);
        if (!priceSnap.exists()) {
          console.warn("priceConfigure document not found");
          return;
        }

        const priceData = priceSnap.data();
        console.log("Fetched price data:", priceData);

        const bulkPrice = parseInt(priceData?.prices?.bulkOrder);

        if (typeof bulkPrice === "number") {
          setPricePerCard(bulkPrice);
        } else {
          console.warn("bulkOrder price not found or invalid");
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const generateOrderId = () => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yy = String(now.getFullYear()).slice(-2);
    const random = Math.floor(1000 + Math.random() * 9000);
    return `${random}${dd}${mm}${yy}`;
  };

  const handleSubmit = async () => {
    const validInputs = bulkOrderInputs.filter(
      (item) => item.rationCardNumber && item.name
    );
    const totalPrice = bulkOrderInputs.length * pricePerCard;

    if (!validInputs.length) {
      return alert("Please enter at least one valid record.");
    }

    if (agentData.credits < totalPrice) {
      return alert("Insufficient credits to place this order.");
    }

    try {
      const orderId = generateOrderId();
      const docRef = doc(collection(db, "bulkOrders"));

      await setDoc(docRef, {
        orderId,
        uid: agentData.uid,
        accountId: agentData.accountId,
        username: agentData.username,
        orders: validInputs,
        status: "pending",
        sentBy: agentData.role,
        timestamp: serverTimestamp(),
      });

      // Deduct credits
      const agentRef = doc(db, "users", agentData.uid);
      await updateDoc(agentRef, {
        credits: agentData.credits - totalPrice,
      });

      alert("Bulk order submitted successfully");
      setBulkOrderInputs([{ rationCardNumber: "", name: "" }]);
      setActiveTab("credits");
    } catch (err) {
      console.error("Bulk order error:", err);
      alert("Failed to submit order");
    }
  };

  if (!agentData) {
    return <div className="container mt-5">Loading agent data...</div>;
  }

  if (pricePerCard === null) {
    return <div className="container mt-5">Loading price configuration...</div>;
  }

  return (
    <div className="container mt-4">
      <div className="card p-4">
        {agentData.role === "admin" && (
          <>
            <div className="d-flex flex-row mb-3">
              <h6 className="">
                Enter Details For Bulk Order{" "}
                <span className="text-muted">
                  (Price per card: ₹{pricePerCard})
                </span>
              </h6>
              {/* <div className="mt-3"> */}
              <strong className="ms-5">Total Orders : </strong>{" "}
              {bulkOrderInputs.length} <br />
              <strong className="ms-5">Total Price : </strong> ₹
              {bulkOrderInputs.length * pricePerCard}
              {/* </div> */}
            </div>
          </>
        )}
        <h4>Enter Ration Card Details</h4>
        {bulkOrderInputs.map((input, index) => (
          <div key={index} className="row g-2 mb-2 align-items-center">
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Ration Card Number"
                required
                value={input.rationCardNumber}
                onChange={(e) => {
                  const newInputs = [...bulkOrderInputs];
                  newInputs[index].rationCardNumber = e.target.value;
                  setBulkOrderInputs(newInputs);
                }}
              />
            </div>
            <div className="col-md-5">
              <input
                type="text"
                className="form-control required-asterisk"
                placeholder="Enter any one name of card"
                value={input.name}
                onChange={(e) => {
                  const newInputs = [...bulkOrderInputs];
                  newInputs[index].name = e.target.value;
                  setBulkOrderInputs(newInputs);
                }}
                required
              />
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-danger"
                onClick={() => {
                  const newInputs = bulkOrderInputs.filter(
                    (_, i) => i !== index
                  );
                  setBulkOrderInputs(newInputs);
                }}
                disabled={bulkOrderInputs.length === 1}
              >
                X
              </button>
            </div>
          </div>
        ))}

        <button
          className="btn btn-sm btn-secondary mb-3 w-25"
          onClick={() => {
            const last = bulkOrderInputs[bulkOrderInputs.length - 1];
            if (last.rationCardNumber && last.name) {
              setBulkOrderInputs([
                ...bulkOrderInputs,
                { rationCardNumber: "", name: "" },
              ]);
            } else {
              alert("Please fill current row before adding a new one");
            }
          }}
        >
          + Add Another
        </button>

        <div className="mt-3">
          <button className="btn btn-success" onClick={handleSubmit}>
            Submit Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentBulkOrderRequest;
